<template>
  
    <div class="pop-up">
      <div class="pop-header">
        <span class="pop-title">{{ popupTitle }}</span>
        <button class="btn-pop-close" @click="$.emit('close')">
          닫기<span class="overlay"></span>
        </button>
      </div>
      <div class="pop-body" v-html="popupText">
        
      </div>
      <div class="pop-btn-area">
        <button
          type="submit"
          class="btn-pop btn-submit"
          @click="$.emit('close')"
        >
          확인<span class="overlay"></span>
        </button>
      </div>
    </div>
    <div class="dimed"></div>
  
</template>
<script>
export default {
  name: "popupBtn1",
  props: {
    popupText: String,
    popupTitle: String,
  },
  data() {
    return {};
  },
  watch: {
    popupText(val) {
      if (val != null) {
        this.popupText.replaceAll('\n\r', '<br/>')
      }
    },
  },
  computed: {},
  methods: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>